import React from 'react';
import PropTypes from 'prop-types';
import BaseVideoPlayer from "../../Internals/BaseVideoPlayer";


const HighlightPlayer = ({height,width,videoId}) => (
        <BaseVideoPlayer height={height} width={width} type="video" srcId={videoId} isHighlight/>
    );

HighlightPlayer.propTypes = {
    /** highlight video id */
    videoId : PropTypes.string.isRequired,
    /** Set the video height  */
    height: PropTypes.string,
    /** Set the video width  */
    width: PropTypes.string
};

export default HighlightPlayer;
